import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorPage } from '@guildeducationinc/recess';
import { useLocale } from 'pe-core-frontend';
import { useNavigate } from 'react-router-dom';
import styles from './SsoError.module.scss';
export const SsoError = () => {
    const { t } = useLocale();
    const navigate = useNavigate();
    const goBack = () => navigate('/');
    const searchParams = new URLSearchParams(window.location.search);
    const error = searchParams.get('error') || 'unknown';
    const response = searchParams.get('response');
    const localeKey = `sso.error.${error}`;
    return (_jsx(ErrorPage, { className: styles.container, title: t('SSO Error'), goBack: goBack, message: response || t(localeKey) }));
};
